import { STORAGE_KEYS } from "../config";
import { ENDPOINTS } from "../config/endpoints";
import { LoginRequest, LoginResponse, User } from "../types/auth.types";
import { apiClient } from "../utils/apiClient";
import { TokenManager } from "../utils/tokenManager";

export class AuthService {
  static async login(credentials: LoginRequest): Promise<{ user: User; token: string }> {
    const response = await apiClient.post<LoginResponse>(ENDPOINTS.AUTH.LOGIN, credentials);

    const { token } = response.data;

    TokenManager.setToken(token);

    const user: User = {
      username: credentials.username,
      ownerDocument: credentials.ownerDocument,
      role: "user",
    };

    localStorage.setItem(STORAGE_KEYS.AUTH_USER, JSON.stringify(user));

    return { user, token };
  }

  static async logout(): Promise<void> {
    TokenManager.clearToken();
    localStorage.removeItem(STORAGE_KEYS.AUTH_USER);
  }

  static isAuthenticated(): boolean {
    const user = localStorage.getItem(STORAGE_KEYS.AUTH_USER);
    const hasToken = TokenManager.hasToken();

    return !!(user && hasToken);
  }

  static getCurrentUserFromStorage(): User | null {
    const userStr = localStorage.getItem(STORAGE_KEYS.AUTH_USER);

    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch {
        return null;
      }
    }

    return null;
  }
}
